module.exports = __webpack_public_path__ + "media/images/es/logo-ocu-b7f401905e1073e85907aa8930f2312e.png";